import {
  RugbyLeagueEventStatusId,
  RugbyLeagueIncidentId,
} from '@collector/sportsapi-client-legacy'

import { EventStatusIncidentsOnFieldConfig } from '../../../configuration'

const eventStatusToIncidentIdMap: Map<
  RugbyLeagueEventStatusId,
  RugbyLeagueIncidentId[]
> = new Map([
  [
    RugbyLeagueEventStatusId.NotStarted,
    [
      RugbyLeagueIncidentId.MatchAboutToStart,
      RugbyLeagueIncidentId.Kickoff,
      RugbyLeagueIncidentId.FirstHalf,
    ],
  ],
  [
    RugbyLeagueEventStatusId.StartDelayed,
    [
      RugbyLeagueIncidentId.MatchAboutToStart,
      RugbyLeagueIncidentId.Kickoff,
      RugbyLeagueIncidentId.FirstHalf,
    ],
  ],
  [RugbyLeagueEventStatusId.Halftime, [RugbyLeagueIncidentId.SecondHalf]],
  [
    RugbyLeagueEventStatusId.WaitingForExtratime,
    [RugbyLeagueIncidentId.ExtratimeFirstHalf],
  ],
  [
    RugbyLeagueEventStatusId.ExtratimeHalftime,
    [RugbyLeagueIncidentId.ExtratimeSecondHalf],
  ],
  [
    RugbyLeagueEventStatusId.WaitingForPenalty,
    [RugbyLeagueIncidentId.PenaltiesStarted],
  ],
])

const kickOffIncidentId = RugbyLeagueIncidentId.Kickoff
const secondHalfIncidentId = RugbyLeagueIncidentId.SecondHalf

export const eventStatusIncidentsOnFieldConfig: EventStatusIncidentsOnFieldConfig =
  {
    eventStatusToIncidentIdMap,
    secondHalfIncidentId,
    startingSide: {
      incidentId: kickOffIncidentId,
      text: 'Which team will KICK-OFF ?',
    },
  }
